import {route} from "ziggy-js";

export async function addApi(values) {
    return axios.post(route('waitList.add'), values);
}

export const getSizesApi = (id) => {
    return axios.post(route('waitList.getSizes'), {id});
};
